export const navigator = {
    step: "modelSelect",
    steps: [
        {
            step: "modelSelect",
            title: "vehicle select",
            label: "Choose your electric vehicle",
            tag: "Model Page",
            next: "dealerSelect",
            visited: false,
            showNavigation: true,
            pills: {
                item: 1,
                total: 4,
            },
        },
        {
            step: "dealerSelect",
            title: "Select Dealer",
            label: "Choose a dealer",
            tag: "Dealer Page",
            next: "dateSelect",
            previous: "modelSelect",
            visited: false,
            showNavigation: true,
            pills: {
                item: 2,
                total: 4,
            },
        },
        {
            step: "dateSelect",
            title: "Select Time?",
            label: "Select a date",
            tag: "Date Page",
            next: "details",
            previous: "dealerSelect",
            visited: false,
            showNavigation: true,
            pills: {
                item: 3,
                total: 4,
            },
        },
        {
            step: "details",
            title: "Details",
            label: "Your Details",
            tag: "Details Page",
            next: "confirmation",
            previous: "dateSelect",
            visited: false,
            showNavigation: true,
            pills: {
                item: 4,
                total: 4,
            },
        },
        {
            step: "confirmation",
            title: "Confirmation of your appointment request",
            label: "Confirmation of your appointment request",
            tag: "Confirmation Page",
            next: null,
            previous: "dateSelect",
            visited: false,
            showNavigation: true,
            pills: {
                item: 4,
                total: 4,
            },
        },
    ],
};
